var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout default"},[_c('nav',{staticClass:"header"},[_c('app-header')],1),_c('main',{staticClass:"content"},[_vm._t("default")],2),_c('footer',{staticClass:"footer"},[_c('app-footer')],1),_c('CookieAcceptDecline')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }